export default {"src":"https://fishbrain.com/_next/static/media/texas.08ed322d.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};